export default __webpack_public_path__ + "static/media/PositionHover.a72626cc.svg";